@if (params) {
  <rt-requisitions-list-toolbar-container
    [params]="params"
    [newRequisitionsDisabled]="isDefaultFlowMissing"
    [filterCounters]="filterCounters"
    [hasRequisitions]="hasRequisitions"
    [activeTab]="activeTab"
    [viewType]="viewType"
  />
}

<div [class.tiles-view]="viewType === RequisitionsListViewType.Tiles" padding-lr>
  @if (isMissingDefaultFlowInfoboxVisible) {
    <rt-infobox
      [heading]="'app.requisitions.list.no_default_flow_infobox.heading' | translate"
      iconName="warning"
      [isDismissible]="false"
      type="warning"
    >
      {{ 'app.requisitions.list.no_default_flow_infobox.description' | translate }}
    </rt-infobox>
  }
</div>

<div padding>
  @if (viewType === RequisitionsListViewType.Tiles) {
    <rt-requisitions-list-tiles-view-container
      [isLoading]="!isEmptyScope && !isLoaded"
      [requisitionsGroups]="requisitionsGroups"
      [params]="params"
      [collapsedGroups]="collapsedGroups"
      [showGroups]="showGroups"
    />
  }
  @if (viewType === RequisitionsListViewType.Table) {
    <rt-requisitions-list-table-view-container
      [isLoading]="!isEmptyScope && !isLoaded"
      [requisitionsGroups]="requisitionsGroups"
      [params]="params"
      [collapsedGroups]="collapsedGroups"
      [showGroups]="showGroups"
    />
  }
</div>
